export default function getPhoneNumber(phoneStyled = '') {
  return phoneStyled.replace('+', '00')
    .replace(/\D/g, '');
}
